import { EnvironmentDetail } from '@utils/EnvironmentDetailUtils';
import { BaseCoralHandler } from './BaseCoralHandler';

export class IIBCoralHandler extends BaseCoralHandler {
    protected static authMethod = 'makeIIBAjaxRequest';
    protected static authValidator = () => EnvironmentDetail.isIIBAuthN();
    protected static handlerName = 'IIBCoralHandler';
}
